import Vue from 'vue';
import ActivityRules from '../../../libs/business-logic/Activities.rules';
import OrderRules from '../../../libs/business-logic/Order.rules';

export default {
  SET_ADDITIONAL_ORDERS_ACTIVITIES: (state, payload) => {
    const additionalOrders = OrderRules.getAdditionalOrders([...payload]);
    const additionalOrdersActivities = ActivityRules
      .getAdditionalOrdersActivities(additionalOrders);
    Vue.set(state, 'additionalOrdersActivities', additionalOrdersActivities);
  },

  SET_ACTIVITIES_GROUPED_BY_ID: (state, payload) => {
    Vue.set(state, 'activitiesGroupedById', payload);
  },

  SET_PARENT_SUPERORDER_ACTIVITIES: (state, payload) => {
    Vue.set(state, 'parentSuperorderActivities', payload);
  },
};
